export function Logo({ size = 16, onClick }: { size?: number; onClick?: () => void }) {
  return (
    <div className="logo" onClick={onClick} style={{ fontSize: size }}>
      <span className="logo-mark" style={{ width: size + 4, height: size + 4 }}>›</span>
      <span>insta<span className="accent">dash</span></span>
    </div>
  )
}
